import shared from "../../../shared.module.css";
import Yatai from "./yatai/Yatai";
import UpgradeItem from "../../upgrade-item/UpgradeItem";
import daimyoEstateIcon from "../../../icons/Hojo_Clan_AoE4.webp";
import ProductionSpeedModifierId from "../../../data/production-speed-modifiers/ProductionSpeedModifierId";
import {toggleProductionSpeedModifier} from "../../../state/ProducationSpeedModifiersSlice";
import {useAppDispatch, useAppSelector} from "../../../hooks";

function SengokuDaimyoFeatures() {
    const dispatch = useAppDispatch();
    const productionSpeedModifiers: { [key: string]: boolean } = useAppSelector((rootState) => rootState.productionSpeedModifiers);


    let daimyoEstate = <UpgradeItem icon={daimyoEstateIcon}
                                           selected={productionSpeedModifiers[ProductionSpeedModifierId.DAIMYO_ESTATE]}
                                           onClick={() => dispatch(toggleProductionSpeedModifier(ProductionSpeedModifierId.DAIMYO_ESTATE))}
                                           tooltip={{header: 'Daimyo Estate', text: 'Increases production speed of military establishments by 20%'}}/>

    return (
        <div className={shared.civilizationSpecificFeatures}>
            <div>Fishing Boats are 25% cheaper</div>
            <Yatai/>
            <div className={shared.upgradesRow}>
                {daimyoEstate}
            </div>
        </div>
    );
}

export default SengokuDaimyoFeatures;
